import map               from 'lodash/map'
import {nullOrUndefined} from './utils.js';

// Public: Convert camel case text into separate words.
export function camelCaseToWords(string, { downcase = false, sentenceCase = false } = {}) {
  if (typeof string != 'string') return string

  let results = string.split(/(?=[A-Z])/)
                      .join(' ')

  if (downcase == true) {
    results = results.toLowerCase()
  }
  else if (sentenceCase == true) {
    results = results.toLowerCase()
    results = capitalize(results)
  }

  return results
}

// Public: Capitalize the first letter of a string.
//
// string - Capitalize this string.
//
// Returns a capitalized string.
export function capitalize(string) {
  if(nullOrUndefined(string)) {
    return '';
  }

  return string.charAt(0).toUpperCase() + string.slice(1, string.length);
}

// Public: Capitalize all words in a string; remove hyphens and underscores.
//
// string - string to capitalize
//
// Returns: string
export function capitalizeAllWords(string) {
  if(nullOrUndefined(string)) {
    return '';
  }

  return map(string.split(/[ \-_]/), capitalize).join(' ');
};

// Public: Remove HTML tags from a string.
//
// string - Strip tags from this string.
//
// Returns a string with HTML tags removed.
export function stripHtml(string) {
  if (typeof string != 'string') return ''

  return string.replace(/<[^>]*>/g, '')
}

// Public: Converts HTML to a formatted string
//
// string - String to process
//
// Returns a string
export function convertHTMLToString(string) {
  const container = document.createElement('div')

  container.innerHTML = string

  // Format tables
  container.querySelectorAll('table').forEach(table => {
    const tableText = Array.from(table.rows)
                           .map(row => Array.from(row.cells)
                                            .map(cell => cell.innerText.trim())
                                            .join('\t'))
                           .join('\n')

    table.replaceWith(document.createTextNode(tableText))
  })

  document.body.appendChild(container)

  const plainText = container.innerText

  container.remove()

  return plainText
}

// Public: Convert common words to appropriate case or symbol
//
// string - string to process
//
// Returns a string
export function convertStopWords(string) {
  var matches = {
        'And': '&',
        'Of' : 'of',
        'Hr' : 'HR'
      };

  return string.split(/\s/)
               .map(function(word) {
                 return matches[word] || word;
               })
               .join(' ');
}


// Public: Converts an Object into a querystring.
//
// obj - Object
//
// Returns a string.
export function objectToQueryString(obj) {
  return new URLSearchParams(obj).toString()
}

// Public: Convert the given string into a permalink slug.
//
// string - String to change.
//
// Returns a String.
export function permalize(string) {
  return string.replace(/[ _]/g, '-')
               .replace(/[^\w-]+/g, '')
               .replace(/-+/g, '-')
               .toLowerCase()
}

// Public: Pluralizes the text based on the variable count
//
// string - String to change
// num    - Number of things counted
//
// Returns a String
export function pluralize(string, num) {
  if (num == 1) return string

  return `${string}s`
}

// Public: Converts a URL querysting into an object
//
// string - querystring (e.g. document.location.search)
//
// Returns an Object
export function queryStringToObject(string) {
  return Object.fromEntries(
    new URLSearchParams(string)
  )
}


// Public: Trim white space off the front and back of the given string.
//
// string - Trim this string.
//
// Returns a string with white space trimmed off the front and back.
export function trim(string) {
  if(nullOrUndefined(string)) {
    return string;
  }

  return string.replace(/^\s+|\s+$/g, '');
}


// Public: Trim the trailing slash from a string.
//
// string - Trim the trailing slash from this string.
//
// Examples
//
//   i4cp.s.trimSlash('/this/is/a/test/'); // => '/this/is/a/test'
//   i4cp.s.trimSlash('/this/is/a/test');  // => '/this/is/a/test'
//
// Returns a string.
export function trimSlash(string) {
  return string.replace(/\/$/, '')
};

// Public: Truncate a string to the desired length (without cutting words)
//
// str - String to trim
// len - Max length
//
// Returns a string
export function truncate(str, len) {
  if (!str || str.length <= len) return str

  const truncated = str.slice(0, len + 1)
  const lastSpace = truncated.lastIndexOf(' ')

  return `${lastSpace > 0 ? truncated.slice(0, lastSpace) : str.split(' ')[0]}...`
}

// Public: return the number of words in the post body
//
// post - return the word count from this post
export function wordCount(text) {
  return text.split(/\W/).length
};
